// extracted by mini-css-extract-plugin
export default {"confirmModal":"TalkModal_confirmModal__sK9zX","closeModalButtonContainer":"TalkModal_closeModalButtonContainer__NyHbD","closeModalButton":"TalkModal_closeModalButton__zjQqx"};